"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var CircleIconLink = function CircleIconLink(_a) {
  var id = _a.id,
      className = _a.className,
      disabled = _a.disabled,
      label = _a.label,
      helper = _a.helper,
      iconName = _a.iconName,
      href = _a.href,
      onClick = _a.onClick,
      htmlAttrs = _a.htmlAttrs;
  var Component = href ? "a" : "button";
  var uuid = id || uniqid_1["default"]("lsg-circleiconlink-");

  var internalOnClick = function internalOnClick(e) {
    var elm = document.getElementById(uuid);
    elm.classList.remove(CSSPrefix_1.lsgPre + "icon__click-anchor"); // tslint:disable-next-line

    void elm.offsetWidth; // https://css-tricks.com/restart-css-animation/#article-header-id-0

    elm.classList.add(CSSPrefix_1.lsgPre + "icon__click-anchor");
    return onClick && onClick(e);
  };

  return React.createElement(Component, __assign({
    id: uuid,
    href: !disabled && href && href,
    onClick: !disabled && internalOnClick,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "circleIconLink", !disabled && (href || onClick) && CSSPrefix_1.lsgPre + "icon__hover-anchor", disabled && CSSPrefix_1.lsgPre + "circleIconLink__disabled", !href && !onClick && CSSPrefix_1.lsgPre + "circleIconLink__non-interactive", className])
  }, htmlAttrs), React.createElement(Icon_1.Icon, {
    className: CSSPrefix_1.lsgPre + "circleIconLink-icon",
    name: iconName,
    size: Icon_1.Icon.Sizes.SMALL,
    color: disabled && Icon_1.Icon.Colors.DISABLED || !href && !onClick && Icon_1.Icon.Colors.SECONDARY || Icon_1.Icon.Colors.ANTHRACITE
  }), React.createElement("span", {
    className: CSSPrefix_1.lsgPre + "circleIconLink-texts"
  }, React.createElement("span", {
    className: CSSPrefix_1.lsgPre + "circleIconLink-label"
  }, label), React.createElement("span", {
    className: CSSPrefix_1.lsgPre + "circleIconLink-helper"
  }, helper)));
};

exports.CircleIconLink = CircleIconLink;